// extracted by mini-css-extract-plugin
export default {"wrapper":"fviOY","icon":"h4on6","text":"G8SkN","spinner":"dq8Ab"};